"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAuthController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const common_2 = require("@nestjs/common");
const simple_auth_service_1 = require("./simple-auth.service");
const simple_auth_swagger_1 = require("./simple-auth.swagger");
const swagger_1 = require("@nestjs/swagger");
const create_simple_auth_dto_1 = require("../../../../service-lib/src/lib/dto/create-simple-auth.dto");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const refresh_token_dto_1 = require("../simple-auth/dto/refresh-token.dto");
let SimpleAuthController = class SimpleAuthController {
    constructor(simpleAuthService) {
        this.simpleAuthService = simpleAuthService;
    }
    // Login endpoint
    async login(loginDto, res) {
        try {
            const user = await this.simpleAuthService.validateUser(loginDto.userName, loginDto.password);
            return res.status(common_2.HttpStatus.OK).json({
                statusCode: common_2.HttpStatus.OK,
                message: messages_1.successMessage.userLoggedIn,
                data: user,
            });
        }
        catch (error) {
            if (error instanceof common_1.ForbiddenException) {
                return res.status(common_2.HttpStatus.FORBIDDEN).json({
                    statusCode: common_2.HttpStatus.FORBIDDEN,
                    message: error.message,
                });
            }
            else if (error instanceof common_1.NotFoundException) {
                return res.status(common_2.HttpStatus.NOT_FOUND).json({
                    statusCode: common_2.HttpStatus.NOT_FOUND,
                    message: error.message,
                });
            }
            return res.status(common_2.HttpStatus.INTERNAL_SERVER_ERROR).json({
                statusCode: common_2.HttpStatus.INTERNAL_SERVER_ERROR,
                message: error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.internalServerError,
            });
            // Handle the error appropriately, e.g., throw a specific exception
        }
    }
    // User details endpoint
    async getUserDetails(req, res) {
        try {
            const userDetails = await this.simpleAuthService.getUserDetails(parseInt(req?.headers?.userid));
            return res.status(common_2.HttpStatus.OK).json({
                statusCode: common_2.HttpStatus.OK,
                message: messages_1.successMessage.userDetailsRetrieved,
                data: userDetails,
            });
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.userNotFound, error?.message, messages_1.errorMessages.failedToFindUser);
        }
    }
    async refreshToken(refreshTokenDto, res) {
        try {
            // Validate the refresh token and generate a new access token
            const { accessToken } = await this.simpleAuthService.validateRefreshTokenAndGenerateAccessToken(refreshTokenDto.refreshToken);
            return res.status(common_2.HttpStatus.OK).json({
                statusCode: common_2.HttpStatus.OK,
                message: messages_1.successMessage.tokenRefreshed,
                data: { accessToken },
            });
        }
        catch (error) {
            if (error instanceof common_1.ForbiddenException) {
                return res.status(common_2.HttpStatus.FORBIDDEN).json({
                    statusCode: common_2.HttpStatus.FORBIDDEN,
                    message: error.message,
                });
            }
            return res.status(common_2.HttpStatus.INTERNAL_SERVER_ERROR).json({
                statusCode: common_2.HttpStatus.INTERNAL_SERVER_ERROR,
                message: error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.internalServerError,
            });
        }
    }
};
exports.SimpleAuthController = SimpleAuthController;
tslib_1.__decorate([
    (0, common_1.Post)("login"),
    (0, simple_auth_swagger_1.loginSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof create_simple_auth_dto_1.CreateSimpleAuthDto !== "undefined" && create_simple_auth_dto_1.CreateSimpleAuthDto) === "function" ? _b : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], SimpleAuthController.prototype, "login", null);
tslib_1.__decorate([
    (0, common_1.Get)("user-details"),
    (0, simple_auth_swagger_1.getUserDetailsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_d = typeof Request !== "undefined" && Request) === "function" ? _d : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], SimpleAuthController.prototype, "getUserDetails", null);
tslib_1.__decorate([
    (0, common_1.Post)("refresh-token"),
    (0, simple_auth_swagger_1.refreshTokenSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_f = typeof refresh_token_dto_1.RefreshTokenDto !== "undefined" && refresh_token_dto_1.RefreshTokenDto) === "function" ? _f : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], SimpleAuthController.prototype, "refreshToken", null);
exports.SimpleAuthController = SimpleAuthController = tslib_1.__decorate([
    (0, swagger_1.ApiTags)("SimpleAuth") // Grouping the endpoints under "SimpleAuth"
    ,
    (0, common_1.Controller)(""),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof simple_auth_service_1.SimpleAuthService !== "undefined" && simple_auth_service_1.SimpleAuthService) === "function" ? _a : Object])
], SimpleAuthController);
